/**
 * W1-11b (app-shell-ui): ICU select branch names may only use letters, digits and `_` (src/i18n/icu.ts; in full
 * ICU '.' is pattern syntax too). Ids with dots or dashes ('sel.any', 'chart.preview', 'focus.lane') are passed to
 * a `select` through `selectKey`, and the shell's catalogue spells its branches the same way ('sel_any',
 * 'chart_preview'). The raw id goes in a second parameter when the `other` branch prints it.
 */
export function selectKey(id: string): string {
  return id.replace(/[^A-Za-z0-9_]/g, '_');
}
